<div class="row">
    <div class="col-12">
        <div class="row">
            <p><b>Não jogue sua senha fora até ser atendido.</b></p>
        </div>
    </div>
    <button mat-flat-button color="primary" class=" block" type="button" (click)="close()">
        <span>Confirmar</span>
    </button>
</div>